import React, {useCallback, useMemo, useRef} from 'react'
import {DateRangeBox} from 'devextreme-react'
import {attachDateRangeBoxGuards} from './analiz-price-period'

export const AnalizPricePeriodRange = React.memo(function AnalizPricePeriodRange({
    period1,
    period2,
    byMonths,
    onValueChanged,
}) {
    const periodRangeRef = useRef(null)
    const value = useMemo(() => [period1, period2], [period1, period2])

    const onOpened = useCallback((e) => {
        attachDateRangeBoxGuards(e?.component || periodRangeRef.current?.instance)
        const elem = document.querySelector('.dx-overlay-wrapper')
        if (!elem) return
        elem.classList.toggle('red-class', !!byMonths)
    }, [byMonths])

    return (
        <DateRangeBox
            ref={periodRangeRef}
            value={value}
            onValueChanged={onValueChanged}
            applyValueMode="useButtons"
            displayFormat={byMonths ? 'MM.yyyy' : 'dd.MM.yyyy'}
            calendarOptions={{
                maxZoomLevel: byMonths ? 'year' : 'month',
                minZoomLevel: 'century',
            }}
            onOpened={onOpened}
            showClearButton
        />
    )
})
